import { useDispatch } from 'react-redux';
import api from './axiosInstance.js';
import {
  setAutoCompletePrompts,
  setAutoCompletePromptsError,
  setPromptSuggestionList,
  setPromptSuggestionListError,
  setPromptSuggestionListLoading,
  setRecentlyUsedPrompt
} from '../redux/promptSuggestion.js';

export const usePromptSuggestion = () => {
  const dispatch = useDispatch();

  const fetchRecentlyUsedPrompts = async () => {
    try {
      const response = await api.get(`/recently-used-prompt`);

      dispatch(setRecentlyUsedPrompt(response.data));
      return response;
    } catch (error) {
      console.error('Error fetching recent prompts:', error);
    }
  };

  const fetchPromptSuggestions = async (prompt) => {
    if (!prompt?.trim()) return;
    const payload = {
      user_prompt: prompt
    };

    try {
      dispatch(setPromptSuggestionListLoading(true));

      const response = await api.get(`/font-suggestion?${new URLSearchParams(payload).toString()}`);

      const suggestionData = response?.data?.data;

      if (suggestionData) {
        const suggestions = Object.keys(suggestionData)
          .filter((key) => key.startsWith('Suggestion'))
          .map((key) => suggestionData[key]);

        dispatch(setPromptSuggestionList(suggestions));
        dispatch(setAutoCompletePrompts(suggestions));
        return suggestions;
      } else {
        dispatch(setPromptSuggestionListError('No suggestions found'));
      }
    } catch (error) {
      dispatch(
        setPromptSuggestionListError(error?.response?.data?.message || 'Something went wrong')
      );
    }
  };

  const fetchAutoCompletePrompts = async (prompt) => {
    if (!prompt?.trim()) return;
    const payload = {
      user_prompt: prompt
    };

    try {
      const response = await api.get(`/font-suggestion?${new URLSearchParams(payload).toString()}`);

      return response;
    } catch (error) {
      dispatch(setAutoCompletePromptsError('No suggestions found'));
    }
  };

  return {
    fetchRecentlyUsedPrompts,
    fetchPromptSuggestions,
    fetchAutoCompletePrompts
  };
};
